import { render, staticRenderFns } from "./TheVerify.vue?vue&type=template&id=cc8b18c8&scoped=true"
import script from "./TheVerify.vue?vue&type=script&lang=js"
export * from "./TheVerify.vue?vue&type=script&lang=js"
import style0 from "./TheVerify.vue?vue&type=style&index=0&id=cc8b18c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b18c8",
  null
  
)

export default component.exports